import { Card } from '../components/core/Card.jsx'
import { Button } from '../components/core/Button.jsx'

// "Did you mean Pest control?" — what was typed under "Something else" reads as
// one of the listed industries. Decided 2026-10-12: duplicates are stopped at
// the door **by the customer**, so this asks and never decides. Setup and the
// review page both show it, because both are a way in.
//
// `match` is `{ key, label, industry }` from `IndustryMatcher::Match#to_props`.
// The page passes the two actions, because what "use it" does differs: setup
// switches the industry and leaves the customer to start, while the review
// page has a business already and starts collecting at once — so that page
// passes the sentence saying so.
//
// `explanation` is for the free check, which asks one question rather than
// twenty, so the default sentence would describe something it does not do.
// Shared rather than under `signed_in/` because the grader is a marketing page.
export function IndustryMatchCard({ match, useLabel, onUse, onKeep, processing = false, note = null, explanation = null }) {
  return (
    <Card variant="signal" title={`Did you mean ${match.label}?`}>
      <div className="flex flex-col gap-4">
        <p className="max-w-[62ch] text-[13.5px] text-[color:var(--text-body)]">
          {explanation ?? (
            <>
              {match.label} is one of our listed industries, with twenty questions we have already
              written and tested. If “{match.industry}” is something different, keep it and we will
              write questions for it instead.
            </>
          )}
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <Button variant="primary" as="button" type="button" loading={processing} onClick={onUse}>
            {useLabel ?? `Use ${match.label}`}
          </Button>
          <Button variant="secondary" as="button" type="button" disabled={processing} onClick={onKeep}>
            Keep “{match.industry}”
          </Button>
        </div>
        {note && <p className="max-w-[62ch] text-[13.5px] text-[color:var(--text-muted)]">{note}</p>}
      </div>
    </Card>
  )
}

// The question stays only while the words it quotes are still in the field;
// once they change it is about something nobody typed.
export function stillAsking(match, typed) {
  if (!match) return false
  const norm = (s) => (s ?? '').trim().replace(/\s+/g, ' ').toLowerCase()
  return norm(match.industry) === norm(typed)
}
